
import Scatter from './scatter';
import BubbleDataset from '../_internal/datasets/bubble';
import BubbleDatasetGroup from '../_internal/datasets/groups/bubble';

class Bubble extends Scatter {
  /**
   * Provides the name of the chart extension
   *
   * @static
   * @return {string} The name of the chart extension
   */
  static getName () {
    return 'Bubble';
  }

  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'Bubble';
  }
  __setDefaultConfig () {
    super.__setDefaultConfig();
    let config = this.config;
    config.friendlyName = 'Bubble Chart';
    config.enablemousetracking = true;
  }

  // This method return the dataset definations for this charts
  getDSdef () {
    return BubbleDataset;
  }

  getDSGroupdef () {
    return BubbleDatasetGroup;
  }
}
export default Bubble;
